<template>
    <v-app id="inspire">
        <v-navigation-drawer v-model="drawer" app>
            <v-list dense>
                <v-list-item v-if="selectedLocation!=null && (hasAccess('SCHEDULE') || hasAccess('COMPLETERO'))" :to="{ name: 'trips', params: { locationId: selectedLocation, locationDepartmentId: selectedDepartment }}">
                    <v-list-item-action>
                        <v-icon>mdi-anchor</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Schedules</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="selectedLocation!=null  && selectedDepartment!=null && activeRequisitionOrder!=null" :to="{ name: 'materials', params: { locationId: selectedLocation, locationDepartmentId: selectedDepartment, requisitionOrderId: activeRequisitionOrder.id }}">
                    <v-list-item-action>
                        <v-icon>mdi-table-search</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Materials</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="selectedLocation!=null  && selectedDepartment!=null" :to="{ name: 'favoritelists', params: { locationId: selectedLocation, locationDepartmentId: selectedDepartment }}">
                    <v-list-item-action>
                        <v-icon>mdi-playlist-check</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Favorite Lists</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="activeRequisitionOrder!=null && selectedDepartment!=null" :to="{ name: 'requisitionorder', params: { locationId: selectedLocation, locationDepartmentId: selectedDepartment, id: activeRequisitionOrder.id }}">
                    <v-list-item-action>
                        <v-icon>mdi-cart</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Active Order</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="selectedLocation!=null" :to="{name:'orderhistory', params: { locationId: selectedLocation}}">
                    <v-list-item-action>
                        <v-icon>mdi-clipboard-check-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Order Select</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <NotificationMenu />
                <v-list-item to="/preferences">
                    <v-list-item-action>
                        <v-icon>mdi-cog</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Preferences</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/users" v-if="hasAccess('USERADMIN')">
                    <v-list-item-action>
                        <v-icon>mdi-account-group</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>User Administration</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/roles" v-if="hasAccess('ROLEADMIN')">
                    <v-list-item-action>
                        <v-icon>mdi-shield-account-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Roles Administration</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="mgr.signOut()">
                    <v-list-item-action>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ vrsUser.fullName }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text v-if="vrsSync.isMaster && hasAccess('CHANGELOCATION')">Location</v-card-text>
                <v-list-item v-if="vrsSync.isMaster && hasAccess('CHANGELOCATION')">
                    <v-select :items="locations"
                              item-text="name"
                              item-value="id"
                              v-model="selectedLocation"
                              solo></v-select>
                </v-list-item>
                <v-card-text v-if="hasAccess('CHANGEDEPT')">Department</v-card-text>
                <v-list-item>
                    <v-select :items="departments"
                              v-if="hasAccess('CHANGEDEPT')"
                              item-text="name"
                              item-value="id"
                              v-model="selectedDepartment"
                              solo></v-select>
                </v-list-item>
                <v-list-item class="hidden-md-and-up">
                    <v-list-item-content>
                        <v-list-item-title>&copy; {{ new Date().getFullYear() }} - Clearwater Seafoods LP</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app
            :color="vrsEnvironment.color || 'indigo'"
            dark>

            <template v-slot:default="{ }">
                <v-row v-if="activeTrip!=null">
                    <v-col><v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>VRS</v-col>
                    <v-col cols="6" class="sm-and-down ma-3">
                        <span class="text-md-h5 my-3" v-if="selectedTripDetails && Object.keys(selectedTripDetails).length != 0"><v-icon>mdi-anchor</v-icon> {{selectedTripDetails.schedule.name || ""}}<v-icon>mdi-chevron-right</v-icon></span>
                        <span class="text-md-h5 my-3" v-if="activeRequisitionOrder!=null"><v-icon>mdi-cart</v-icon> {{activeRequisitionOrder.orderSubType || ""}}</span>
                        <span class="text-md-h5 my-3" v-if="activeRequisitionOrder!=null && activeRequisitionOrder.description"> - {{activeRequisitionOrder.description}}</span>
                        <span class="caption" v-if="activeRequisitionOrder!=null">
                            ({{ activeRequisitionOrder.orderCode}})</span>
                        <v-chip class="ml-3" v-if="activeRequisitionOrder!=null && !activeRequisitionOrder.isActive" color="orange" close close-icon="mdi-close-circle" @click:close="resetActiveOrder()">Not Active</v-chip>
                    </v-col>
                    <v-col cols="3"  class="sm-and-down ma-3"><span class="text-md-h6 ma-3"><v-icon>mdi-anchor</v-icon>{{activeTrip.schedule.name || "No Active Schedule"}}</span></v-col>
                    
                </v-row>
            </template>

        </v-app-bar>

        <v-main>
            <Snackbar />
            <router-view :key="$route.path"></router-view>
        </v-main>
        <v-footer :color="vrsEnvironment.color || 'indigo'"
            app>
            <span class="hidden-sm-and-down  white--text">&copy; {{ new Date().getFullYear() }} - Clearwater Seafoods LP</span>
            <v-spacer class="hidden-sm-and-down" />
            <span class="white--text mr-4">{{ vrsEnvironment.name }} - {{ selectedDepartmentName || "No department selected" }}</span>
            <v-spacer class="hidden-md-and-up" />
            <NotificationButton />
        </v-footer>

        <v-overlay :value="overlay" opacity="0.75" absolute>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-app>
</template>

<script>
    import { mapGetters, mapActions, mapState } from 'vuex';
    import Snackbar from "@/components/Snackbar";
    import NotificationMenu from "@/components/NotificationMenu";
    import NotificationButton from "@/components/NotificationButton";
    import Mgr from '@/SecurityService'
    import axios from "axios";

    export default {
        props: {
            source: String,
        },
        data: () => ({
            drawer: false,
            vrsUser: { fullName:""},
            vrsEnvironment: {},
            vrsSync: {},
            departments: [],
            locations: [],
            selectedLocation: null,
            selectedDepartment: null,
            activeTrip: null,
            activeRequisitionOrder: null,
            selectedRequisitionOrderId: null,
            selectedTripDetails: {},
            unwatchDepartment: null,
            unwatchLocation: null,
            overlay: false,
            mgr: new Mgr()
        }),
        components: {
            Snackbar,
            NotificationMenu,
            NotificationButton
        },
        computed: {
            ...mapGetters(['getRefreshActiveTrip','getActiveOrder', 'hasAccess']),
            ...mapState(['activeOrder']),
            selectedDepartmentName() {
                return this.departments.find(d => d.id == this.selectedDepartment)?.name;
            }
        },
        watch: {
            getRefreshActiveTrip: {
                async handler() {
                    this.setActiveTrip(await this.getActiveTrip(this.selectedLocation));
                }
            },
            async getActiveOrder(newValue,oldValue) {
              if(newValue===0) {
                this.activeRequisitionOrder = await this.getActiveRequisitionOrder(this.selectedLocation.id)
              }
              else {
                this.activeRequisitionOrder = await this.getRequisitionOrder(newValue);
              }
            },
            activeRequisitionOrder: {
                async handler() {
                    if (this.activeRequisitionOrder) {
                        this.selectedTripDetails = await this.getScheduleDetails(this.activeRequisitionOrder.scheduleId);
                    }
                }
            }

        },
        created() {
            this.startSignalR();
        },
        async mounted() {
            this.drawer = false;
            this.overlay = true;

            try {
                this.vrsEnvironment = await this.getEnvironmentInfo();
                this.vrsSync = await this.getSyncInfo();

                this.vrsUser = await this.getUserInfo();

                await this.loadVrsUserInfo();
                await this.loadEnvironment();
                await this.loadNotifications();

                this.locations = await this.getLocations();

                if (this.vrsSync.isMaster) {
                    this.selectedLocation = this.locations.find(l => l.id == this.vrsUser.locationId)?.id;
                } else {
                    this.selectedLocation = this.locations.find(l => l.id == this.vrsSync.origin)?.id;
                }
                
                this.departments = await this.getDepartments(this.selectedLocation);
                
                this.selectedDepartment = this.departments.find(d => d.departmentId == this.vrsUser.departmentId)?.id;

                if (this.selectedLocation) {
                    this.setActiveTrip(await this.getActiveTrip(this.selectedLocation));
                }

            } catch (e) {
                this.drawer = true;
                this.overlay = false;
                console.log(`Failed to load required information. Error message: ${e}`);
            }

            this.drawer = true;
            this.overlay = false;

            //Set the watches programmatically after the data has loaded to avoid race-conditions.
            //Assign the watches to an "unwatch" so we can disable them when route values change.
            this.unwatchDepartment = this.$watch('selectedDepartment', this.watchSelectedDepartment);

            this.unwatchLocation = this.$watch('selectedLocation', this.watchSelectedLocation);
        },
        methods: {
            async getEnvironmentInfo() {
                let response = await axios.get(`/api/System/environment`);
                return response.data;
            },
            async getSyncInfo() {
                let response = await axios.get(`/api/System/sync`);
                return response.data;
            },
            async getUserInfo() {
              let username=await this.mgr.getUsername();
              let response = await axios.get(`/api/User/${username}`);
              return response.data;
            },
            async getDepartments(locationId) {
              let response = await axios.get(`/api/location/${locationId}/departments`);    
              return response.data;
            },
            async getLocations(locationId) {
                let response = await axios.get(`/api/location`);
                return response.data;
            },
            async getActiveRequisitionOrder(locationId) {
                let response = await axios.get(`/api/Location/${locationId}/activerequisitionorder`);
                return response.data;
            },
            async getRequisitionOrder(orderId) {
              let response = await axios.get(`/api/RequisitionOrder/${orderId}`);
              return response.data;
            },
            async getActiveTrip(locationId) {
                try {
                    let response = await axios.get(`/api/schedule/location/${locationId}/activetrip`);
                    return response.data;
                } catch(e) {
                    console.log(e);
                    return null;
                }

            },
            async getScheduleDetails(scheduleId) {
                try{
                    let response = await axios.get(`/api/schedule/${scheduleId}`);
                    return response.data;
                } catch(e) {
                    console.log(e);
                    return null;
                } 
            },
            async resetActiveOrder() {
              this.setActiveTrip(await this.getActiveTrip(this.selectedLocation));
            },
            async watchSelectedLocation(newValue, oldValue) {
                //Suspend the watch on department while updating location to avoid
                //multiple dataloads
                this.unwatchDepartment();

                this.setActiveTrip(await this.getActiveTrip(this.selectedLocation));

                this.departments = await this.getDepartments(newValue);
                this.selectedDepartment = this.departments.find(d => d.departmentId == this.vrsUser.departmentId)?.id;

                //Update route parameters
                this.$route.params.locationId = newValue;
                this.$route.params.id = this.selectedRequisitionOrderId;
                this.$route.params.requisitionOrderId = this.selectedRequisitionOrderId;
                this.$route.params.locationDepartmentId = this.selectedDepartment;

                //Navigate to existing page with new route params.
                //Use $route.push to maintain history in browser.
                try {
                    await this.$router.push({ name: this.$route.name, params: this.$route.params });
                } catch (e) {
                    //Catching redundant navigation exception
                }
                this.unwatchDepartment = this.$watch('selectedDepartment', this.watchSelectedDepartment);
            },
            async watchSelectedDepartment(newValue, oldValue) {
                this.$route.params.locationDepartmentId = newValue;

                try {
                    await this.$router.push({ name: this.$route.name, params: this.$route.params });
                } catch (e) {
                    //Catching redundant navigation exception
                }
            },
            setActiveTrip(activeTrip) {

                if (activeTrip && activeTrip.schedule) {

                    this.activeTrip = activeTrip;

                    if (activeTrip.requisitionOrders && activeTrip.requisitionOrders[0]) {

                        this.activeRequisitionOrder = this.activeTrip.requisitionOrders[0];
                        this.selectedRequisitionOrderId = this.activeRequisitionOrder.id;

                    } else {

                        this.activeRequisitionOrder = null;
                        this.selectedRequisitionOrderId = -1;
                    }

                } else {
                    this.activeTrip = { schedule: { name: 'No Active Trip.' } };
                    this.activeRequisitionOrder = null;
                    this.selectedRequisitionOrderId = -1;
                }



            },
            ...mapActions(['loadVrsUserInfo', 'loadNotifications', 'loadEnvironment'])
        }
    }
</script>